"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const i18next_1 = __importDefault(require("i18next"));
function default_1({ confirm, nickname }) {
    confirm({
        description: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("img", { width: "100%", src: "/static/common/images/img_user_profile_add.png" }), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("span", Object.assign({ css: { display: 'flex', justifyContent: 'center' } }, { children: `${i18next_1.default.t('폰디도 nickname님을 사랑해요', { nickname })}..🧡` }))] })),
        cancellationButtonProps: { style: { display: 'none' } },
    });
}
exports.default = default_1;
